<template>
  <div>
    <span class="title">
      快速注册
    </span>
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item prop="name">
        <el-input @blur="allStrTrim('name')" v-model.trim="form.name" maxlength="50" placeholder="请输入真实姓名">
          <template slot="prepend">
            姓名
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="phone">
        <el-input @input="filterChinese('phone')" v-model.trim="form.phone" maxlength="11" placeholder="请输入手机号">
          <template slot="prepend">
            +86
            <i class="el-icon-arrow-right"></i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="phoneCode" class="phoneCode" v-if="isPhoneFormItem">
        <el-input @input="filterChinese('phoneCode')" v-model="form.phoneCode" maxlength="6" placeholder="请输入验证码"></el-input>
        <div style="font-family: PingFangSC" :class="isPhoneBtnClick ? 'phoneBtn phoneBtn-click' : 'phoneBtn phoneBtn-default'" @click="getTestCode">
          {{ isPhoneBtnClick ? phoneBtnTxt + '秒' : phoneBtnTxt }}
        </div>
      </el-form-item>
      <div class="islider" v-if="isCode">
        <Slider
          @close="isCode = false"
          :log="true"
          @getImg="getImg"
          @validImg="validImg"
        ></Slider>
      </div>
    </el-form>
    <div class="data-bottom-btn" @click="nextStepClick" style="font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600">
      {{ btnText }}
    </div>
    <el-dialog
      title="提示"
      :visible.sync="regSourceShow"
      width="600px"
      show-divider
      show-shadow
      class="dialog-center"
      :close-on-click-modal="false"
      :before-close="handleClose"
      custom-class="el-dialog--customize"
    >
      <span>{{ dialogContent }}</span>
      <span slot="footer">
          <el-button size="mini" type="default-mini" @click="regSourceShow = false"
          >取消</el-button
          >
          <el-button size="mini" type="primary-font-mini" @click="regSourceGo"
          >确定</el-button
          >
        </span>
    </el-dialog>
  </div>
</template>

<script>
import validators from '@/utils/validators'
// getSendMsg
import { getSendMsg, getCheckMobile, getImageVerifyCode} from '@/api/register-shop'
import Slider from "../../common/slider";
export default {
  name: "registerBasic",
  components: {
    Slider
  },
  data () {
    return {
      regSourceShow: false,
      dialogContent: '您的商家开店申请还未完成，请继续完善信息后提交',
      btnText: '验证手机号并继续',
      phoneBtnTxt: '发送验证码',
      isPhoneBtnClick: false,
      isPhoneFormItem: true,
      form: {
        name: '',
        phone: '',
        phoneCode: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          {
            // pattern: /^[\u4e00-\u9fa5A-Za-z\s\·\(\)\（\）]+$/,
            // message: '请正确填写姓名',
            pattern: /^((?!.*(&)).)*$/,
            message: '不可输入&',
            trigger: 'blur'
          }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            validator: validators.mobile,
            message: '请输入正确格式的手机号码',
            trigger: 'blur'
          }
        ],
        phoneCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 6, message: '请输入6位验证码' }
        ]
      },
      businessName: '',
      isCode: false, // 拼图滑块
      show: true // 手机验证码的按钮
    }
  },
  methods: {
    allStrTrim (key) {
      this.form[key] = this.form[key].trim()
    },
    regSourceGo () {
      sessionStorage.setItem('businessName', this.businessName)
      this.$router.replace('/business-open-shop/apply-shop-info')
      this.$store.dispatch('businessOpenShopSetStep', 3)
    },
    // 校验联系人手机号接口
    getCheckMobile () {
      let submitParams = {
        name: this.form.name,
        phone: this.form.phone,
        authCode: this.form.phoneCode,
        // isShowLoading: true,
        // loadingMessage: '验证中,请稍等...',
        isShowPageLoading: true
      }
      getCheckMobile(submitParams).then(res => {
        console.log(res, '校验联系人手机号接口')
        if (res.data.code === '0') {
          let registerInfo = {}
          registerInfo.contactName = this.form.name
          registerInfo.phone = this.form.phone
          this.$store.state.app.userRegisterInfo = {
            contactName: this.form.name,
            phone: this.form.phone,
            authCode: this.form.phoneCode,
            shopId: res.data.data.shopId
          }
          if (res.data.data.shopState) {
            this.$router.replace('/business-open-shop/approval/' + this.$crypto.Encrypt(res.data.data.shopId + '') + '/' + this.$crypto.Encrypt(res.data.data.shopState + ''))
            // this.$router.replace('/business-open-shop/approval/' + res.data.data.shopId + '/' + res.data.data.shopState)
            sessionStorage.setItem('businessName', res.data.data.businessName)
            if (res.data.data.shopState === 4) {
              this.$store.state.app.resultInfo = {
                shopId: res.data.data.shopId,
                result: res.data.data.result,
                shopState: res.data.data.shopState,
                businessName: res.data.data.businessName
              }
            }
            this.$store.dispatch("businessOpenShopSetStep", 5)
            return false
          }
          if (res.data.data.businessName) {
            this.regSourceShow = true
            this.businessName = res.data.data.businessName
            return false
          }
          if (res.data.data.businessNames.length) {
            this.$emit('clickNext', { businessNames: res.data.data.businessNames, registerInfo: JSON.parse(JSON.stringify(registerInfo)) })
            return false
          }
          this.$emit('clickNext', { businessNames: res.data.data.businessNames, registerInfo: JSON.parse(JSON.stringify(registerInfo)) })
        }
      }).catch(() => {
        this.form.phoneCode = ''
      })
    },
    // 发送短信验证码接口
    getSendMsg (blcokLeft,id,callback) {
      getSendMsg({ phone: this.form.phone, captchaVail: { x: blcokLeft, catuid: id }}).then(res => {
        console.log(res, '发送短信验证码接口')
        if(res.data.code == "0"){
          callback({data:true});
          this.isCode = false;
          this.show = false;
          let timer
          this.isPhoneBtnClick = true
          this.phoneBtnTxt = 60
          timer = setInterval(() => {
            this.phoneBtnTxt = --this.phoneBtnTxt
            if (!this.phoneBtnTxt) {
              this.isPhoneBtnClick = false
              this.phoneBtnTxt = '发送验证码'
              clearInterval(timer)
            }
          }, 1000)
        }else {
          callback({data:false,message:res.data.message});
          this.isCode = true;
          this.show = true;
        }
      })
    },
    nextStepClick () {
      console.log("我走了")
      this.$refs['form'].validate((valid) => {
        if (valid) {
          console.log("我也走了")
          this.getCheckMobile()
        }
      })
    },
    handleClose(done) {
      done()
    },
    phoneBtnClick (blcokLeft,id,callback) {
      this.getSendMsg(blcokLeft,id,callback)

    },
    filterNumber () {
      this.form.name = this.form.name.replace(/[^\u4e00-\u9fa5]/g,'')
    },
    filterChinese (name) {
      this.form[name] = this.form[name].replace(/[^\d.]/g, "");
    },
    // 获取滑动验证码的图片
    getImg(callback) {
      getImageVerifyCode({}).then((res) => {
        callback(res.data);
      }, error => {
        callback(error);
      });
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(blcokLeft, id, callback) {
      // blcokLeft,// 手动定位返回的值
      //   id// 后台返回的id，再传回去
      this.phoneBtnClick(blcokLeft,id,callback); // 登陆请求方法
    },
    getTestCode () {
      this.$refs['form'].validateField('phone', (valid) => {
        if (!valid) {
          if (!this.isPhoneBtnClick) {
            this.isCode= true;
          }
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-form-item {
  margin-bottom: 20px;
}

/deep/ .el-input {
  width: 500px;
  input {
    height: 40px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .el-input-group__prepend {
    width: 72px !important;
    border-right: 0;
    background: #fff;
    color: #4A4A4A;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    text-align: center;
    padding: 0px !important;
    .el-icon-arrow-right {
      transform: rotate(90deg);
    }
  }
}
.phoneCode {
  .el-input {
    width: 370px;
  }
  /deep/ .el-form-item__content {
    display: flex;
    .phoneBtn {
      width: 110px;
      height: 40px;
      border-radius: 4px;
      font-size: 13px;
      font-weight: 400;
      color: #fff;
      line-height: 40px;
      text-align: center;
      margin-left: 20px;
      cursor: pointer;
    }
    .phoneBtn-default {
      background-color: rgba(255, 20, 47, 1);
      &:hover {
        background: #f50b25;
      }
    }
    .phoneBtn-click {
      background: #CCCCCC;
      border: 1px solid rgba(204,204,204,1);
      color: #999999;
    }
  }
}
.title {
  font-size: 20px;
  color: #4A4A4A;
  line-height: 28px;
  display: block;
  font-weight: 600;
  margin-bottom: 20px;
}
.islider{
    width: 400px;
    height: 265px;
    background: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0px 4px 6px 0px rgba(201,201,201,0.5), 4px 0px 4px 0px rgba(229,229,229,0.5);
    position:absolute;
    left:232px;
    top: -158px;
  }
.islider::before {
  position: absolute;
  bottom: -11px;
  left:50%;
  content: '';
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid rgba(0, 0, 0, .1);
}
.islider::after {
  position: absolute;
  bottom: -11px;
  left:50%;
  content: '';
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid #ffffff;
  filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, .2));
}
/deep/ .el-form {
  position: relative;
}
</style>
